import { render, staticRenderFns } from "./UserShipmentOptions.vue?vue&type=template&id=82cceee4&scoped=true&"
import script from "./UserShipmentOptions.vue?vue&type=script&lang=js&"
export * from "./UserShipmentOptions.vue?vue&type=script&lang=js&"
import style0 from "./UserShipmentOptions.vue?vue&type=style&index=0&id=82cceee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cceee4",
  null
  
)

export default component.exports